import cn from 'classnames';
import { FC } from 'react';

import { ChecklistDisplayRow } from '../../config';

import styles from './ChecklistTagList.module.scss';

type ChecklistTagListProps = {
  rows: ChecklistDisplayRow[];
  className?: string;
};

export const ChecklistTagList: FC<ChecklistTagListProps> = (props) => {
  const { rows, className } = props;

  return (
    <div className={className} data-component="checklist-tag-list">
      {rows.map((row, index) => (
        <div key={row.key} className={styles.row}>
          <span className={cn('p3b', styles.sectionChip)}>
            {index + 1}. {row.label}
          </span>
          {row.valueTokens.map((token, tokenIndex) => (
            <span
              key={`${row.key}-${tokenIndex}-${token.value}`}
              className={cn(
                'p3',
                styles.valueChip,
                token.kind === 'ai' && styles.aiChip,
              )}
            >
              {token.value}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};
